<template>
  <v-content>
    <v-container fluid>
      <BeepDetailsDialog ref="detailsDialog" />

      <v-card>
        <v-toolbar class="card-bar">
          <v-btn icon @click="$router.push('/beeper/sources')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>Beeps</v-toolbar-title>
          <v-btn icon class="ml-2" @click="reload">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-spacer />
        </v-toolbar>

        <OPaginatedTable
          :spec="spec"
          :items="rows"
          :count="count"
          :navigation="nav"
          @update:navigation="v => (nav = v)"
          @rowClicked="selectRow"
        />
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
import { Beep } from '../models'
import { brLongDateTime } from 'oderon-commons/src/formatters'

export default {
  components: {
    OPaginatedTable: require('oderon-vue/cpts/OPaginatedTable').default,
    BeepDetailsDialog: require('./BeepDetailsDialog').default
  },
  props: {
    sources: {},
    tags: {}
  },
  data() {
    return {
      rows: [],
      count: 0,
      nav: {
        limit: 20,
        offset: 0
      },

      cloud: [],

      spec: {
        defaultSortable: false,
        columns: [
          { t: 'Source', d: 'source' },
          { t: 'Timestamp|', d: 'createdAt', f: brLongDateTime },
          {
            t: 'Tags',
            d: 'tags'
          },
          { t: 'Contents', d: 'contents' }
        ]
      }
    }
  },
  computed: {
    apiParams() {
      return {
        sources: this.sources,
        tags: this.tags,
        limit: this.nav.limit,
        offset: this.nav.offset
      }
    }
  },
  mounted() {
    this.reload()
  },
  watch: {
    apiParams() {
      this.reload()
    }
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    reloadFromStart() {
      this.nav.offset = 0
    },

    async fetchData() {
      let data = await Beep.findAll(this.apiParams)
      this.rows = data.rows
      this.count = data.count

      // Para a busca da tag-cloud, considera apenas
      // os últimos 30d.
      // let cloudParams = {
      //   fromDate: moment()
      //     .add(-30, 'd')
      //     .format('YYYY-MM-DD'),
      //   ...this.apiParams
      // }

      // let cloud = await findTagCloud(cloudParams)
      // this.cloud = cloud
    },

    async selectRow(row) {
      let dialog = this.$refs.detailsDialog
      await dialog.open(row.id)
    }
  }
}
</script>

<style></style>
